(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9752],{

/***/ 72961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ AntisocialPage; }
});

// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/index.tsx + 3 modules
var Ir = __webpack_require__(82319);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Heading.tsx
var Heading = __webpack_require__(3319);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Paragraph.tsx
var Paragraph = __webpack_require__(81507);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Ir/Governance/Antisocial/index.tsx










var AntisocialPage = function AntisocialPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      enTitleText: "Policy Against Antisocial Forces",
      subTitleText: ""
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
        children: "The fundamental approach to excluding antisocial forces and the current status of our efforts in this regard"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "The company operates under the policy of not engaging with any antisocial forces that may adversely affect societal order or the sound activities of the corporation. In line with this commitment, we disseminate and enforce the 'TRIAL Code of Conduct' and the 'Measures Against Antisocial Forces' regulations among the directors and employees of our corporate group. We are actively working to eliminate ties with antisocial forces and promote corporate ethics throughout the entire corporate group."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 20,
          pc: 30
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "Internally, we have established a framework where the Group Legal Manager is the overall responsible party for handling issues related to troubles involving civil intervention violence. Additionally, we instruct and implement the inclusion of clauses related to the exclusion of business partners and antisocial forces in contracts across various departments. To counter pressures from antisocial forces, we have also built collaborative relationships with external specialized organizations such as police stations and the Corporate Defense Measures Council."
      })]
    })]
  });
};

AntisocialPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'Home',
    path: '/en/'
  }, {
    name: 'Investor Relations',
    path: '/en/ir/'
  }, {
    name: 'Corporate Governance',
    path: '/en/ir/governance/'
  }, {
    name: 'Policy Against Antisocial Forces',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "Policy Against Antisocial Forces",
      description: "The fundamental approach to eliminate antisocial forces and the current status of our efforts this regard.",
      ogp: {
        url: 'en/ir/governance/antisocial/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/en/ir/governance/antisocial.tsx


/***/ }),

/***/ 60570:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/governance/antisocial",
      function () {
        return __webpack_require__(72961);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,4591,4123,9774,2888,179], function() { return __webpack_exec__(60570); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);